
export default {
  props: {
    size: {
      type: Number,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
    vertical: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getstyle() {
      return {
        background: this.color,
        ...(this.vertical
          ? { height: `${this.size}%` }
          : { width: `${this.size}%` }),
      }
    },
  },
}
